import CashFundPreferences from './cash-fund-preferences'

export default CashFundPreferences
